import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  output,
  SimpleChanges,
} from '@angular/core';
import {
  CcdlBrandComponent,
  CcdlDividerComponent,
  CcdlInitialsPipe,
  CcdlMenuDropdownComponent,
  DropdownList,
  SelectedOption,
} from '@cpm-pr1618001/ng-design-lib';
import { AccountInfo } from 'src/app/store/state/init.state';
import {
  AccountMessage,
  Notifications,
} from 'src/app/store/user-management/state/user-management.state';
import {
  ContactPayload,
  RequestStatus,
} from '../dashboard/store/state/dashboard.state';
import { NotificationsComponent } from './notifications/notifications.component';

@Component({
  selector: 'fm-header-ui',
  standalone: true,
  imports: [
    CcdlBrandComponent,
    CcdlDividerComponent,
    CcdlMenuDropdownComponent,
    NotificationsComponent,
    CcdlInitialsPipe,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnChanges {
  @Input() userDropdownList!: DropdownList[];
  @Input() accountInfo!: AccountInfo;
  @Input() messages: AccountMessage[] = [];
  @Input() notifications: Notifications[] = [];
  @Input() isAddContactProcessing = false;

  readonly brandMobileSrc: string = 'images/capvizon_logo_ylw.png';
  readonly brandDesktopSrc: string = 'images/capvizon_brand_logo.png';
  readonly brandHomeRoute: string = '/dashboard/home';

  selectedOptionEvent = output<SelectedOption>();
  addChosenContactEmitter = output<ContactPayload>();
  onLoadMoreNotificationsEmitter = output<number>();

  accountName: string;
  mobileMenuOptions: DropdownList[] = [];
  desktopMenuOptions: DropdownList[] = [];
  messgesList: DropdownList[];

  messageTextOnTop: string | number = '';
  notificationTextOnTop: string | number = '';
  dismissModal = false;
  // This key is used to force the dropdown menu to re-render when the menu is clicked,
  // which helps in closing the menu when a click occurs outside of it.
  dropdownMenuOpenKey: number = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.accountInfo?.currentValue) {
      this.accountName = `${this.accountInfo.accountDetails.firstName} ${this.accountInfo.accountDetails.lastName}`;
    }
    if (changes?.userDropdownList?.currentValue) {
      this.mobileMenuOptions = [...this.userDropdownList];
      this.desktopMenuOptions = [
        ...this.userDropdownList.filter(
          (option: DropdownList) => option.id !== 3 && option.id !== 4,
        ),
      ];
    }
    if (changes?.messages?.currentValue) {
      this.generateMessagesList();
    }

    if (changes?.notifications?.currentValue) {
      this.notificationTextOnTop = this.notifications.length;
    }
    this.dismissModal = false;
  }

  generateMessagesList(): void {
    this.messgesList = [];
    // this.messages.forEach((val: AccountMessage, key: number) => {
    //   const options: Messages = {
    //     id: val.id,
    //     firstName: val.firstName,
    //     lastName: val.lastName,
    //     date: val.date,
    //     message: val.message,
    //     type: 'MESSAGES',
    //     value: val.message,
    //     label: val.message,
    //   };
    //   this.messgesList.push(options);
    // });
    this.messageTextOnTop = this.messgesList.length;
  }

  menuClick(): void {
    this.dismissModal = false;
    this.dropdownMenuOpenKey = this.dropdownMenuOpenKey + 1;
  }

  selectedOption(event: SelectedOption): void {
    this.selectedOptionEvent.emit(event);
  }

  onContactDeclined(notification: Notifications): void {
    const payload: ContactPayload = {
      userId: String(notification.contactUserId),
      status: RequestStatus.REQUEST_DENIED,
      contact: {
        id: notification.uId,
        email: notification.email,
      },
    };
    this.dismissModal = true;
    this.addChosenContactEmitter.emit(payload);
  }

  onContactAccepted(notification: Notifications): void {
    const payload: ContactPayload = {
      userId: String(notification.contactUserId),
      status: RequestStatus.REQUEST_APPROVED,
      contact: {
        id: notification.uId,
        email: notification.email,
      },
    };
    this.dismissModal = true;
    this.addChosenContactEmitter.emit(payload);
  }

  onLoadMoreNotifications(offsetLimit: number): void {
    this.onLoadMoreNotificationsEmitter.emit(offsetLimit);
  }
}
